import Engine from '@ember/engine';
export default Engine;